import React from 'react';
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container container">
            <h2 className="footer__title">Indranil</h2>

            <ul className="footer__list">
                <li>
                    <a href="#about" className="footer__link">About</a>
                </li>

                <li>
                    <a href="#portfolio" className="footer__link">Projects</a>
                </li>
            </ul>

            <div className="footer__social">
                <a href="https://www.youtube.com/@indranilbhuin" className="footer__social-link" target="_blank" rel="noreferrer">
                    <i class='bx bxl-youtube' ></i>
                </a>
                <a href="https://www.instagram.com/indranilbhuin/" className="footer__social-link" target="_blank" rel="noreferrer">
                    <i class='bx bxl-instagram' ></i>
                </a>
                <a href="https://www.getrevue.co/profile/indranilbhuin" className="footer__social-link" target="_blank" rel="noreferrer">
                    <i class='bx bxs-news'></i>
                </a>
            </div>

            <span className="footer__copy">
                &#169; Indranil Bhuin, All rights reserved
            </span>
        </div>
    </footer>
  )
}

export default Footer